import React,{useState, useEffect} from 'react'
import { useMqtt } from '../../../../context/MqttContext'
import DeviceChatBox from './DeviceChatBox'

function DeviceComponent({device}) {

    const {mqClient,publishMessage} = useMqtt();
    const [newChat,setNewChat] =  useState(null);

    const connectDevice = () =>{
        mqClient.on('connect', () => {
            mqClient.subscribe(device.topicBase+"status", function (err) {
                if (!err) {
                    console.log("subscribed to topic : ",device.topicBase+"status")
                    // Publish a message to a topic
                    /*
                    let message = {
                        "message":"Hello Megamind"
                    }
                    mqClient.publish(device.topicBase+"ready","isready")
                    */
                } else {
                    console.log("error on subscribe",err)
                }
            })
        })
    }


    
   
    const onMessage = () =>{
        mqClient.on('message', function (topic, message) {
            // message is Buffer
            if(topic.includes(device.topicBase)){
                console.log("message received for "+topic);
                let m = message.toString();
                let messageObj = JSON.parse(m);
                console.log("Message received");
                console.log("message is ",m)

                let _msg = {
                    deviceName : device.title,
                    msg:messageObj.reply,
                    messageObj:messageObj
                }
                setNewChat(_msg)
            }
            //client.end()
        })
    }


    useEffect(()=>{
        if(mqClient !== null){
            connectDevice();
            onMessage();
        }
    },[mqClient])

    console.log("i am rerendered for "+device.title);
    return (
        <div className="card mb-2">
            <div className="card-header">{device.title}</div>
            <div className="card-body">
                <DeviceChatBox device={device} publishMessage={publishMessage} newChat={newChat} setNewChat={setNewChat}  />
            </div>
        </div>
    )
}

export default DeviceComponent